/** @format */
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { setSearchParams } from '@toucan/client/global/nextjs';

export const useSearchResultsInfiniteScroll = ({
    showAll,
    totalResults,
    pageIndex,
    resultsPerPage,
    onNextPage,
}: {
    showAll: boolean;
    totalResults: number;
    pageIndex: number;
    resultsPerPage: number;
    onNextPage?: (page: number) => void;
}) => {
    const router = useRouter();

    const [ref, inView] = useInView({
        rootMargin: '100px',
    });

    useEffect(() => {
        if (inView) {
            // Exit if show all is not enabled but continue to observe the trigger
            if (!showAll || totalResults === 0) {
                return;
            }

            // Exit if we have reached the last page stop
            const nextPageIndex = pageIndex + 1;
            const nextPage = nextPageIndex + 1;
            const numPages = Math.ceil(totalResults / resultsPerPage);
            if (nextPageIndex > numPages - 1) {
                return;
            }

            // increment our page and set it to the url which will trigger a results fetch
            if (onNextPage) {
                onNextPage(nextPage);
                return;
            }

            setSearchParams(router, { page: nextPage }, false);
        }
    }, [inView]);

    return ref;
};
